export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_640000-77ee178850e11ec57641d9a419e4c100.avif";